import { render, staticRenderFns } from "./IDP.vue?vue&type=template&id=6e112485"
import script from "./IDP.vue?vue&type=script&lang=js"
export * from "./IDP.vue?vue&type=script&lang=js"
import style0 from "./IDP.vue?vue&type=style&index=0&id=6e112485&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports